/* utils/sanitizeCoords.ts -------------------------------------------- */
export function sanitizeCoords(raw: any[]): number[][] {
  const out: number[][] = [];
  for (const c of raw) {
    if (
      Array.isArray(c) &&
      c.length >= 2 &&
      Number.isFinite(c[0]) &&
      Number.isFinite(c[1])
    ) {
      if (out.length === 0) {
        out.push([...c]);
      } else {
        const prev = out[out.length - 1];
        if (prev[0] !== c[0] || prev[1] !== c[1]) {
          out.push([...c]); // keep z if present
        }
      }
    }
  }
  return out;
}
